import { useObservableStore } from 'src/services/rxjs-redux/hook';
import { useSpaceViewsSelector } from 'src/services/spaces/space-views';
import { useCurrentSpaceView, useCurrentSpaceViewId } from '../space';

export const useFavoritePages = () => {
  const currentSpaceViewId = useCurrentSpaceViewId();

  return useSpaceViewsSelector((state) => {
    const spaceView = state[currentSpaceViewId];
    if (!spaceView) return [];
    return spaceView.favoritePages;
  });
};

export const useHasFavoritePages = () => {
  const spaceView = useCurrentSpaceView();

  return useObservableStore(
    ({ blocks }) => {
      return spaceView?.favoritePages.some((id) => blocks[id]);
    },
    [spaceView?.favoritePages]
  );
};
